export default __webpack_public_path__ + "static/media/servicetype_cnc_192.91c6a6e9.png";